class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.comboHandlersInitialized = false;
    this.handleDrawerClick = this.handleDrawerClick.bind(this);
    this.addEventListener('click', this.handleDrawerClick);
     this.handleDrawerBannnerCick = this.handleDrawerBannnerCick.bind(this);
    this.addEventListener('click', this.handleDrawerBannnerCick);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    
    if (!this.comboHandlersInitialized) {
      setTimeout(() => {
        this.initComboHandlers();
      }, 100);
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      
      // Re-initialize combo handlers after content is rendered
      this.comboHandlersInitialized = false;
      this.initComboHandlers();
      this.dispatchSlideshowRefresh();      
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initComboHandlers() {
    if (this.comboHandlersInitialized) {
      console.log('Combo handlers already initialized, skipping...');
      return;
    }

    console.log('Initializing combo handlers...');
    
    const comboPlusBtn = this.querySelector('[data-combo-action="comboPlus"]');
    const comboMinusBtn = this.querySelector('[data-combo-action="comboMinus"]');
    const comboDisplayInput = this.querySelector('#Drawer-combo-display-quantity');
    
    console.log('Found elements:', {
      plusBtn: !!comboPlusBtn,
      minusBtn: !!comboMinusBtn,
      displayInput: !!comboDisplayInput
    });
    
    if (comboPlusBtn && comboMinusBtn && comboDisplayInput) {
      // Remove old event listeners by cloning
      const newPlusBtn = comboPlusBtn.cloneNode(true);
      const newMinusBtn = comboMinusBtn.cloneNode(true);
      
      comboPlusBtn.parentNode.replaceChild(newPlusBtn, comboPlusBtn);
      comboMinusBtn.parentNode.replaceChild(newMinusBtn, comboMinusBtn);
      const hiddenInputs = document.querySelectorAll('.combo-quantity-input');
      console.log('Found before', hiddenInputs.length, 'hidden inputs');
      console.log("check hidden: ", hiddenInputs);
      
      // Add fresh event listeners with proper event handling
      newPlusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // Don't use stopPropagation - let it bubble normally
        
        console.log('Plus button clicked');
        
        const currentValue = parseInt(comboDisplayInput.value) || 0;
        const newValue = currentValue + 1;
        
        console.log('Updating quantity from', currentValue, 'to', newValue);
        
        const hiddenInputs = document.querySelectorAll('.combo-quantity-input');
        console.log('Found', hiddenInputs.length, 'hidden inputs');
        
        if (hiddenInputs.length === 0) {
          console.error('No hidden inputs found! Cannot update cart.');
          return;
        }
        
        const updates = {};
        hiddenInputs.forEach((input) => {
          const cartKey = input.getAttribute('data-combo-key');
          const baseQty = parseInt(input.getAttribute('data-base-qty')) || 1;
          const lineQty = baseQty * newValue; // keep ratio
          updates[cartKey] = lineQty;
          console.log('Will update key:', cartKey, 'to', lineQty);
        });

        
        // this.updateComboQuantity(updates, newValue, comboDisplayInput);
      });
      
      // Add fresh event listeners to minus button
      newMinusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // Don't use stopPropagation - let it bubble normally
        
        console.log('Minus button clicked');
        
        const currentValue = parseInt(comboDisplayInput.value) || 0;
        const newValue = Math.max(0, currentValue - 1);
        
        console.log('Updating quantity from', currentValue, 'to', newValue);
        
        const hiddenInputs = document.querySelectorAll('.combo-quantity-input');
        console.log('Found', hiddenInputs.length, 'hidden inputs');
        
        if (hiddenInputs.length === 0) {
          console.error('No hidden inputs found! Cannot update cart.');
          return;
        }
        
        const updates = {};
        hiddenInputs.forEach((input) => {
          const cartKey = input.getAttribute('data-combo-key');
          const baseQty = parseInt(input.getAttribute('data-base-qty')) || 1;
          const lineQty = baseQty * newValue; // keep ratio
          updates[cartKey] = lineQty;
          console.log('Will update key:', cartKey, 'to', lineQty);
        });
        
        // this.updateComboQuantity(updates, newValue, comboDisplayInput);
      });
      
      this.comboHandlersInitialized = true;
      console.log('Combo handlers initialized successfully');
    } else {
      console.log('Could not initialize combo handlers - missing elements');
    }
        
    // Handle combo product removal
    const comboRemoveBtns = this.querySelectorAll('[data-combo-remove="true"] button');

    if (comboRemoveBtns.length) {
      console.log('Found remove button(s), attaching handler');
      
      comboRemoveBtns.forEach((removeBtn) => {
        // Clone to remove old listeners
        const newRemoveBtn = removeBtn.cloneNode(true);
        removeBtn.parentNode.replaceChild(newRemoveBtn, removeBtn);
        
        newRemoveBtn.addEventListener('click', (e) => {
          e.preventDefault();
          
          console.log('Remove button clicked');
          
          const comboRow = newRemoveBtn.closest('.cart-item--combo');
          const hiddenInputs = comboRow?.querySelectorAll('.combo-quantity-input') || [];
          console.log('Found', hiddenInputs.length, 'hidden inputs for removal');
          
          if (hiddenInputs.length === 0) {
            console.error('No hidden inputs found! Cannot remove combo from cart.');
            return;
          }
          
          // Build updates object with all quantities set to 0
          const updates = {};
          hiddenInputs.forEach((input) => {
            const cartKey = input.getAttribute('data-combo-key');
            updates[cartKey] = 0;
            console.log('Will remove key:', cartKey);
          });
          
          // Show loading spinner
          if (comboRow) {
            const spinner = comboRow.querySelector('.loading__spinner');
            if (spinner) {
              spinner.classList.remove('hidden');
            }
          }
          
          // Remove combo items via AJAX
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          })
            .then((response) => response.json())
            .then((cart) => {
              console.log('Combo removed successfully:', cart);

              if (cart.item_count === 0) {
                console.log('Cart is now empty, reloading empty cart HTML');

                return fetch(window.location.pathname + '?section_id=cart-drawer')
                  .then((response) => response.text())
                  .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const newCartDrawer = doc.querySelector('#CartDrawer');
                    const currentCartDrawer = document.querySelector('#CartDrawer');

                    if (newCartDrawer && currentCartDrawer) {
                      currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                      console.log('Updated cart drawer with empty state');
                    }

                    const newCartIcon = doc.querySelector('#cart-icon-bubble');
                    const currentCartIcon = document.querySelector('#cart-icon-bubble');

                    if (newCartIcon && currentCartIcon) {
                      currentCartIcon.innerHTML = newCartIcon.innerHTML;
                      console.log('Updated cart icon to 0');
                    }

                    this.classList.add('is-empty');
                    this.close();

                    console.log('Cart drawer closed with empty state');
                  });
              }

              return fetch(window.location.pathname + '?section_id=cart-drawer');
            })
            .then((response) => {
              if (!response) return;
              return response.text();
            })
            .then((html) => {
              if (!html) return;

              console.log('Fetched updated cart drawer HTML');

              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');

              const newCartDrawer = doc.querySelector('#CartDrawer');
              const currentCartDrawer = document.querySelector('#CartDrawer');

              if (newCartDrawer && currentCartDrawer) {
                currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                console.log('Updated cart drawer content after removal');
              }

              const newCartIcon = doc.querySelector('#cart-icon-bubble');
              const currentCartIcon = document.querySelector('#cart-icon-bubble');

              if (newCartIcon && currentCartIcon) {
                currentCartIcon.innerHTML = newCartIcon.innerHTML;
                console.log('Updated cart icon');
              }

              this.comboHandlersInitialized = false;
              setTimeout(() => {
                this.initComboHandlers();
              }, 100);
            })
            .catch((error) => {
              console.error('Error removing combo:', error);

              if (comboRow) {
                const spinner = comboRow.querySelector('.loading__spinner');
                if (spinner) spinner.classList.add('hidden');
              }

              const errors = document.getElementById('CartDrawer-CartErrors');
              if (errors) {
                errors.textContent = 'There was an error removing the combo. Please try again.';
              }
            });
        });
      });

      console.log('Remove handler initialized');
    }
  }
  handleDrawerClick(event) {
    const upsellButton = event.target.closest('[data-upsell-button]') || event.target.closest('.fgb-img');
    if (upsellButton && this.contains(upsellButton)) {
      event.preventDefault();
      this.handleUpsellAdd(upsellButton);
    }
  }

  handleUpsellAdd(button) {
    const variantId = button.getAttribute('data-upsell-variant');
    if (!variantId) return;

    button.classList.add('loading');
    button.setAttribute('disabled', 'disabled');

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add item to cart.');
        return response.json();
      })
      .then(() => this.refreshDrawerSections())
      .catch((error) => {
        console.error('Upsell add failed:', error);
        button.classList.add('is-error');
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      });
  }

  handleDrawerBannnerCick(event){
    const bannerButton = event.target.closest('[data-banner-button]');
    if(bannerButton && this.contains(bannerButton)){
      event.preventDefault();
      this.handleUpsellAdd(bannerButton);
    }
  }

  refreshDrawerSections() {
    const sections = this.getSectionsToRender().map((section) => section.id);
    const url = `${window.location.pathname}?sections=${sections.join(',')}`;

    fetch(url)
      .then((response) => response.json())
      .then((sectionsHtml) => {
        console.log('Sections HTML:', sectionsHtml);
        this.renderContents({ sections: sectionsHtml });
      })
      .catch((error) => console.error('Failed to refresh cart drawer:', error));
  }
  dispatchSlideshowRefresh() {
    document.dispatchEvent(
      new CustomEvent('cart:sections-updated', {
        detail: {
          sections: ['cart-drawer'],
        },
      })
    );
  }
  updateComboQuantity(updates, displayValue, displayInputElement) {
    console.log('Updating combo quantity via AJAX...', updates);
    
    if (displayInputElement) {
      displayInputElement.value = displayValue;
    }
    
    const comboRow = this.querySelector('.cart-item--combo');
    if (comboRow) {
      const spinner = comboRow.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }
    }
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart updated successfully:', cart);
      
      // Dispatch event for combo quantity update with updated quantity
      document.dispatchEvent(new CustomEvent('combo:quantity-updated', {
        detail: { cart, source: 'cart-drawer', updatedQuantity: displayValue }
      }));
      
      // Update cart total price
      const totalPriceElement = this.querySelector('.totals__total-value');
      if (totalPriceElement && cart.total_price) {
        const formattedPrice = '₹ ' + (cart.total_price / 100).toFixed(0);
        totalPriceElement.textContent = formattedPrice;
        console.log('Updated total price to:', formattedPrice);
      }
      
      // Update combo line total
      const comboLineTotalElement = this.querySelector('.combo-line-total');
      if (comboLineTotalElement && cart.items) {
        let comboTotal = 0;
        cart.items.forEach(item => {
          if (item.properties && item.properties.Offer) {
            comboTotal += item.final_line_price;
          }
        });
        const formattedComboTotal = '₹ ' + (comboTotal / 100).toFixed(0);
        comboLineTotalElement.textContent = formattedComboTotal;
        console.log('Updated combo line total to:', formattedComboTotal);
      }
      
      // Update cart icon count
      const cartIconBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
      if (cartIconBubble && cart.item_count !== undefined) {
        cartIconBubble.textContent = cart.item_count;
        console.log('Updated cart count to:', cart.item_count);
      }
      
      if (comboRow) {
        const spinner = comboRow.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }
      
      console.log('Combo quantity update complete');
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      
      if (comboRow) {
        const spinner = comboRow.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }
      
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = 'There was an error updating your cart. Please try again.';
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  onCartUpdate() {
    console.log('Cart updated via regular items - re-initializing combo handlers');
    
    // Get the cart-drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (cartDrawer) {
      cartDrawer.comboHandlersInitialized = false;
      
      setTimeout(() => {
        if (cartDrawer.initComboHandlers) {
          cartDrawer.initComboHandlers();
          console.log('Combo handlers re-initialized after cart update');
        }
      }, 100);
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
